"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  input,\n  textarea {\n    padding-left: 0px;\n  }\n\n  text-align: 'right';\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Input_1 = __importDefault(require("@material-ui/core/Input"));

var utils_1 = __importDefault(require("@nexys/utils"));

var MyInput = function MyInput(props) {
  var id = props.id,
      name = props.name,
      data = props.data,
      placeholder = props.placeholder,
      onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var strName = name.toString();
  var initialValue = data && utils_1.default.ds.get(strName, data);

  var _react_1$default$useS = react_1.default.useState(initialValue || ''),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      value = _react_1$default$useS2[0],
      setValue = _react_1$default$useS2[1];

  react_1.useEffect(function () {
    var initialValue = data && utils_1.default.ds.get(strName, data);
    setValue(typeof initialValue === 'number' ? initialValue : '');
  }, [strName, data]);

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    var valueNumber = Number(value);

    if (!isNaN(valueNumber)) {
      onChange({
        name: strName,
        value: valueNumber
      });
      setValue(valueNumber);
    }
  };

  return react_1.default.createElement(StyledInput, {
    type: 'number',
    id: id ? id : strName,
    name: strName,
    value: value,
    onChange: handleChange,
    placeholder: placeholder,
    disabled: disabled,
    inputProps: {
      style: {
        textAlign: 'right'
      }
    },
    fullWidth: true
  });
};

var StyledInput = styled_components_1.default(Input_1.default)(_templateObject());
exports.default = MyInput;